import {
  FETCH_FINANCE_MASTERDATA,
  FETCH_FINANCE_MASTERDATA_LOADING,
  FETCH_FINANCE_MASTERDATA_ERROR,
  INVALIDATE_FINANCE_MASTERDATA,
} from '../actions/constants';

const defaultState = {
  loading: false,
  invoiceData: {},
  payoutData: {},
  error: null,
  isFetched: false,
};

export default function financeMasterDataReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_FINANCE_MASTERDATA_LOADING:
      return {
        ...state,
        loading: true,
      };

    case FETCH_FINANCE_MASTERDATA:
      return {
        ...state,
        loading: false,
        invoiceData: action.data.invoiceData,
        payoutData: action.data.payoutData,
        error: null,
        isFetched: true,
      };

    case FETCH_FINANCE_MASTERDATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case INVALIDATE_FINANCE_MASTERDATA:
      return {
        ...state,
        isFetched: false,
        loading: false,
      };

    default:
      return state;
  }
}
